<p-toast key="appToast" position="top-right"></p-toast>
<router-outlet></router-outlet>